// extracted by mini-css-extract-plugin
export var container = "ConsultantCard-module--container--27019";
export var jobTitle = "ConsultantCard-module--jobTitle--b9013";
export var photo = "ConsultantCard-module--photo--d1c77";
export var specialities = "ConsultantCard-module--specialities--a4d84";
export var title = "ConsultantCard-module--title--d6c6f";